import { render, staticRenderFns } from "./ProductInquiryAll.vue?vue&type=template&id=060e06de&scoped=true"
import script from "./ProductInquiryAll.vue?vue&type=script&lang=js"
export * from "./ProductInquiryAll.vue?vue&type=script&lang=js"
import style0 from "./ProductInquiryAll.vue?vue&type=style&index=0&id=060e06de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060e06de",
  null
  
)

export default component.exports